//大运会 full
import PlatfromCSMeetUniversiadeFull from '@containers/platfrom_compreSportsMeet/universiadeFull_WUSG.vue'

export default {
  PlatfromCSMeetUniversiadeFull,
}
